import { IFilterDate, IOnInit } from "angular";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../../../records/server/serverUtility";
import { MachineGateway } from "../../../../models/machine";
import { MachineConfigurationGateway } from "../../../../models/machineConfiguration";
import {
  MachineConfigurationProgressiveInformation,
  MachineConfigurationProgressiveMap,
  ProgressiveDefinition,
} from "../../../../models/progressiveDefinition";

export class MachineDetailProgressiveConfigurationComponentController
  implements IOnInit
{
  private readonly date: Date;

  static $inject = ["environment", "dateFilter", ServerUtilityName];
  constructor(
    environment: { Date: Date },
    private readonly dateFilter: IFilterDate,
    readonly serverUtility: ServerUtility
  ) {
    this.date = environment.Date;
  }

  readonly machine!: MachineGateway;
  configurations: MachineConfigurationGateway[] = [];
  readonly progressiveInformation: MachineConfigurationProgressiveMap = {};

  $onInit(): void {
    this.configurations = this.machine.Configs ?? [];
  }

  getAccordionHeading(configuration: MachineConfigurationGateway) {
    const configurationDate: Date = configuration.Date!;
    const systemDate: Date = this.date;
    const currentConfiguration: boolean =
      configuration.CurrentConfiguration ?? false;

    const futureChange = configurationDate > systemDate;
    const changeTypeDetail = configuration.ConversionTypeName
      ? `(${configuration.ConversionTypeName})`
      : "";

    return `${configuration.ChangeType}${changeTypeDetail} - ${this.dateFilter(
      configurationDate
    )}${currentConfiguration && !futureChange ? " - Current" : ""}${
      futureChange ? " - Pending" : ""
    }`;
  }

  getProgressiveDefinitionGetterSetter(
    configuration: MachineConfigurationGateway
  ) {
    return ((value: ProgressiveDefinition) => {
      const progressiveInfo = this.progressiveInformation[configuration.Id];
      if (value === undefined) {
        return progressiveInfo?.ProgressiveDefinition;
      }
      if (progressiveInfo !== undefined) {
        progressiveInfo.ProgressiveDefinition = value;
      }
    }).bind(this);
  }
}
